import { Unstable_Grid2 as Grid } from '@mui/material';

import { Select } from '@occc-app/design-system';
import { useMemo } from 'react';
import { useConfig } from '@occc/config';

export type ActiveSubbrandAttributeProps = {
  fieldName: string;
};

export const ActiveSubbrandAttributeAttribute = ({ fieldName }: ActiveSubbrandAttributeProps) => {
  const { config } = useConfig();

  const subBrandOptions = useMemo(
    () => [
      { label: 'Clear Selection', value: '' },
      ...(config.subBrands?.list ?? []).map((subBrand) => ({
        label: subBrand.name,
        value: subBrand.uuid,
      })),
    ],
    [config.subBrands?.list],
  );

  return (
    <Grid container spacing={3}>
      <Grid xs={12} sm={6} md={3}>
        <Select
          name={`${fieldName}.activeSubBrand`}
          label='Active Subbrand'
          data={subBrandOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>
    </Grid>
  );
};
